<template>
  <div class="wavveon-menu-container">
    <div class="wavveon-menu-wrapper">
      <h2 class="agency-name">{{ agencyName }}</h2>
      <ul class="menu-list">
        <li><a href="#" @click.prevent="onClickLogout">Wavve on 나가기</a></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue'
  import cookie from '@/common/utils/cookie'
  import constant from '@/common/resources/constant'

  const props = defineProps({
    agencyName: {
      type: String,
      default: '',
    },
  })

  const showLoginPop = ref(false)

  const onClickLogout = () => {
    cookie.removeItems({ keyList: ['pzInfo', 'cs', 'pz', 'SHARE_KEY'] })
    cookie.setItem(
      'pz',
      JSON.stringify({ isPooqzone: false }),
      false,
      constant.URL_COOKIE_DOMAIN,
      '/',
    )
    localStorage.clear()
    location.href = '/'
  }
</script>

<style lang="scss" scoped>
  .wavveon-menu {
    &-container {
      width: 100%;
      height: 34px;
      border-bottom: 1px solid #2f2f2f;
    }
    &-wrapper {
      position: relative;
      width: 1240px;
      margin: 0 auto;

      .agency-name {
        float: left;
        color: #a5a5a5;
        font-size: 12px;
        line-height: 34px;
        font-weight: 400;
      }
      .menu-list {
        float: right;
        li {
          a {
            text-decoration: none;
            color: #a5a5a5;
            font-size: 12px;
            line-height: 34px;
            font-weight: 400;
          }
        }
      }
    }
  }
</style>
